import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface IKnowledgeBotData {
  name: string;
}

export type KnowledgeBotModel = ITypedModel<IKnowledgeBotData>;

angular.module('capability-ng-priority-feed').factory(
  'ngKnowledgeBotModel',
  () =>
    new Model<IKnowledgeBotData>({
      name: 'Knowledge Bot'
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/models/knowledge_bot_model.ts